import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconCopy = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M14 12H8C6.875 12 6 11.125 6 10V2C6 0.90625 6.875 0 8 0H12.375C12.75 0 13.1562 0.1875 13.4375 0.46875L15.5312 2.5625C15.8125 2.84375 16 3.25 16 3.625V10C16 11.125 15.0938 12 14 12ZM2 4H5V5.5H2C1.71875 5.5 1.5 5.75 1.5 6V14C1.5 14.2812 1.71875 14.5 2 14.5H8C8.25 14.5 8.5 14.2812 8.5 14V13H10V14C10 15.125 9.09375 16 8 16H2C0.875 16 0 15.125 0 14V6C0 4.90625 0.875 4 2 4Z",
		fill: "#2C2C2C"
	})]
});
const ForwardRef = forwardRef(SvgIconCopy);
export { ForwardRef as ReactComponent };
